import React from 'react';
import { SvgIcon, SvgIconProps, useTheme } from '@mui/material';
import { ReactComponent as svg } from './DropDownIcon.svg';

const DropDownIcon = (props: SvgIconProps) => {
  const theme = useTheme();

  return (
    <SvgIcon component={svg} viewBox="0 8 24 25" sx={{
      margin: '0px',
      textAlign: 'center',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      // '& path': {
      //   fill: theme.colors?.buttonIcon.default
      // },
      ...props.sx
    }} {...props} />
  );
};

export default DropDownIcon;
